import React, { useState } from "react";
import dataService from "../../../helpers/dataService";
import tools from "../../../helpers/tools";
import Loader from "../../common/Loader";
import {
  FORMULES,
  STEPS,
  getStatus,
  getVehicleLabel,
} from "./autoRequestLabels";

const AUTORequestCard = ({ request }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState(false);

  const status = getStatus(request.status);
  const vehicle = getVehicleLabel(request.vehicle);
  const formule = FORMULES[request.formula];
  const title = [vehicle || "Votre véhicule", formule && `Formule ${formule}`]
    .filter(Boolean)
    .join(" · ");

  const downloadQuote = () => {
    setDownloadError(false);
    setIsDownloading(true);
    const filename = tools.getDocumentName({
      fileExt: "pdf",
      documentName: "Devis",
      productName: "AUTO",
      companyName: vehicle || undefined,
      uploadedAt: request.requestedAt,
    });
    dataService.downloadFile(
      `customers/me/auto_requests/${request.id}/quote`,
      { filename },
      () => {
        window.dataLayer?.push({ event: "telechargment_pdf", nom_pdf: "DEVIS_AUTO" });
      },
      () => setDownloadError(true),
      () => setIsDownloading(false)
    );
  };

  return (
    <div className="bg-blue border rounded shadow-small p-3 mb-3 w-100 auto-request-card">
      <div className="auto-request-row">
        <div>
          <strong style={{ fontSize: "var(--fs-16)" }}>{title}</strong>
          <p className="auto-meta mb-0">
            Demande envoyée le {tools.formatDate(request.requestedAt)}
          </p>
        </div>
        <span className={`auto-badge ${status.badge}`}>{status.label}</span>
      </div>
      <ol className="auto-steps">
        {STEPS.map((step, index) => {
          const position = index + 1;
          const className =
            position < status.step ? "done" : position === status.step ? "current" : "";
          return (
            <li
              key={step}
              className={className}
              aria-current={position === status.step ? "step" : undefined}
            >
              {step}
            </li>
          );
        })}
      </ol>
      {request.quoteAvailable ? (
        <div className="auto-request-row align-items-center">
          <p className="auto-note mb-0">
            Votre devis est prêt. Téléchargez-le, puis contactez votre
            gestionnaire pour finaliser la souscription.
          </p>
          <button
            type="button"
            className="btn btn-primary text-white"
            style={{ minHeight: 44 }}
            onClick={downloadQuote}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <Loader color="#ffffff" size={24} />
            ) : (
              <>
                <i className="fa fa-download mr-2" aria-hidden="true" />
                Télécharger mon devis
              </>
            )}
          </button>
        </div>
      ) : (
        <p className="auto-note mb-0">
          <i className="fa fa-hourglass-half mr-1" aria-hidden="true" /> Votre
          devis est en cours de préparation.
        </p>
      )}
      {downloadError && (
        <p
          className="mb-0 mt-2"
          role="status"
          aria-live="polite"
          style={{ color: "#a12013", fontWeight: "bold" }}
        >
          Le téléchargement a échoué. Réessayez dans quelques instants.
        </p>
      )}
    </div>
  );
};

export default AUTORequestCard;
